import useAlias from '@alias';
import FormattedAlias from '@components/_shared/Translations/FormattedAlias';
import { Dialog, DialogTitle } from '@mui/material';
import QueryKeys from '@src/constants/queryKeys';
import useUserCreate, {
  AddUserFormValues,
} from '@src/hooks/api/mutations/useUserCreate';
import { Actions } from '@src/types/Actions';
import storeConnector from '@store/storeConnector';
import { useQueryClient } from '@tanstack/react-query';
import AddUserForm from '../Forms/AddUserForm';

interface AddUserDialogProps {
  open: boolean;
  onClose: () => void;
  actions: Actions;
}

function AddUserDialog({ open, onClose, actions }: AddUserDialogProps) {
  const alias = useAlias();
  const queryClient = useQueryClient();
  const { mutate: createUser, isPending } = useUserCreate();

  const handleSubmit = async ({
    passwordConfirmation: _,
    ...values
  }: AddUserFormValues) => {
    createUser(values, {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: [QueryKeys.users] });
        actions.notify(alias('Successfully created user.'));
        onClose();
      },
      onError: (error: Error) => {
        const customError = error.cause as { error?: { message: string } };
        actions.notifyError(
          customError?.error?.message ?? alias('Failed to create user.'),
        );
      },
    });
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth='sm' fullWidth>
      <DialogTitle>
        <FormattedAlias id='Add User' />
      </DialogTitle>
      <AddUserForm
        onCancel={onClose}
        onSubmit={handleSubmit}
        isLoading={isPending}
      />
    </Dialog>
  );
}

export default storeConnector(AddUserDialog, {});
